import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import { getLocalTrasferData } from "../../../../store/Api";

export default function LocaltransferPopUp({ PopUp, setPopUp }) {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState();
  const dispatch = useDispatch();

  const triggerDownload = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (!file) return;

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await nodeinstance.post(
        `/dashboard/localTransfer/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          responseType: "blob", // handle both JSON and Excel responses
        }
      );

      const contentType = response.headers["content-type"] || "";

      if (
        contentType.includes("spreadsheetml") ||
        contentType.includes("octet-stream")
      ) {
        // Validation errors — auto-download annotated Excel
        const failedCount  = response.headers["x-failed-count"]  || "some";
        const successCount = response.headers["x-success-count"] || "0";

        triggerDownload(new Blob([response.data]), "validation_errors.xlsx");

        dispatch(setAppError({
          msg: `${failedCount} row(s) failed validation. ${successCount} row(s) uploaded successfully. Check the downloaded file for details.`,
          color: "error",
        }));

        if (parseInt(successCount) > 0) {
          dispatch(getLocalTrasferData({}));
        }
      } else {
        // All rows valid — parse JSON blob
        const text = await response.data.text();
        const json = JSON.parse(text);

        dispatch(setAppError({
          msg: `Successfully uploaded ${json.successCount} record(s).`,
          color: "success",
        }));
        dispatch(getLocalTrasferData({}));
        setPopUp(false);
      }
    } catch (err) {
      // Axios throws on 4xx/5xx — err.response.data is a Blob
      if (err.response?.status === 422 && err.response?.data instanceof Blob) {
        // Validation errors returned as Excel
        const failedCount  = err.response.headers["x-failed-count"]  || "some";
        const successCount = err.response.headers["x-success-count"] || "0";

        triggerDownload(err.response.data, "validation_errors.xlsx");

        dispatch(setAppError({
          msg: `${failedCount} row(s) failed validation. ${successCount} row(s) uploaded successfully. Check the downloaded file for details.`,
          color: "error",
        }));

        if (parseInt(successCount) > 0) {
          dispatch(getLocalTrasferData({}));
        }
      } else {
        // Other errors — try to parse blob as JSON for a readable message
        let msg = err.message;
        try {
          if (err.response?.data instanceof Blob) {
            const text = await err.response.data.text();
            const json = JSON.parse(text);
            msg = json.error || json.message || msg;
          }
        } catch (_) {}
        dispatch(setAppError({ msg }));
      }
    } finally {
      setPopUp(false);
      setLoading(false);
    }
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
        PopUp ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-lg w-full h-auto rounded-md bg-white/95 flex flex-col p-4 relative">
        <div className="flex justify-between items-center w-full mb-2">
          <h1 className="text-base font-semibold">Upload Local Transfer</h1>
          <button onClick={() => setPopUp(false)}>
            <IoMdClose size="1.2rem" />
          </button>
        </div>

        <form onSubmit={submitHandler} className="w-full">
          <div className="w-full flex flex-col gap-3 my-3 p-5">
            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Select Excel File</span>
              </label>
              <input
                type="file"
                className="file-input file-input-bordered w-full"
                onChange={(e) => setFile(e.target.files[0])}
                required
                accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              />
            </div>
            <p className="text-xs text-slate-500">
              If any rows fail validation, the file will be downloaded automatically
              with a <strong>VALIDATION</strong> column showing all errors per row.
            </p>
            <div className="flex gap-3 w-full justify-center">
              <button
                type="button"
                className="p-3 ring-1 ring-slate-300 rounded-md w-full max-w-xs text-sm"
                onClick={() => setPopUp(false)}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="p-3 bg-red text-white rounded-md w-full max-w-xs flex gap-3 justify-center items-center text-sm"
                disabled={loading}
              >
                <p>Submit</p>
                {loading && <CgSpinner className="animate-spin" />}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
